import { useState } from 'react';
import { prop } from 'ramda';

import { useAppSelector } from '@core/js/store/hooks';

import { useUpdateEffect } from '@interlayer/js/hooks/useUpdateEffect';

export const getMediaQuery = (query) => window.matchMedia(query).matches;
export const getPortraitOrientation = () => window.innerWidth <= window.innerHeight;

export const useMediaQuery = (query) => {
    const resizeData = useAppSelector(prop('resizeData'));
    const [matches, setMatches] = useState(getMediaQuery(query));

    useUpdateEffect(() => {
        setMatches(getMediaQuery(query));
    }, [query, resizeData]);

    return matches;
};

export const usePortraitOrientation = () => {
    const resizeData = useAppSelector(prop('resizeData'));
    const [isPortrait, setPortrait] = useState(getPortraitOrientation());

    useUpdateEffect(() => {
        setPortrait(getPortraitOrientation());
    }, [resizeData]);

    return isPortrait;
};

